<div class="app-root-container">
    <app-login *ngIf="!isAuthenticated"></app-login>
    <app-dialog-host></app-dialog-host>
    <app-generation-toast></app-generation-toast>

    <div *ngIf="isAuthenticated" class="main-layout" [class.editor-layout]="isEditorRoute">
        <div *ngIf="sidebarOpen" class="sidebar-backdrop" (click)="closeSidebar()"></div>
        <nav *ngIf="!isEditorRoute && !isSuperAdmin" class="client-sidebar" [class.open]="sidebarOpen">
            <div class="sidebar-header">
                <div class="nav-brand-icon">
                    <img src="/logo_mia_sidebar.svg" alt="MIA Logo" class="brand-logo-img" />
                </div>
                <div class="sidebar-brand-copy">
                    <span class="sidebar-eyebrow">Workspace cliente</span>
                    <strong>MIA Social Calendar</strong>
                </div>
            </div>

            <div class="sidebar-section">
                <span class="sidebar-section-label">Navigazione</span>
                <div class="nav-links">
                    <button routerLink="/ads-campaigns" routerLinkActive="active" title="Campagne AdS">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                            <path d="M16 2v4"></path>
                            <path d="M8 2v4"></path>
                            <path d="M3 10h18"></path>
                            <path d="M8 14h.01"></path>
                            <path d="M12 14h.01"></path>
                            <path d="M16 14h.01"></path>
                            <path d="M8 18h.01"></path>
                            <path d="M12 18h.01"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Campagne Ads</strong>
                            <small>Calendari editoriali</small>
                        </span>
                    </button>

                    <button routerLink="/posts" routerLinkActive="active" title="Contenuti">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                            <path d="M7 8h10"></path>
                            <path d="M7 12h10"></path>
                            <path d="M7 16h6"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Contenuti</strong>
                            <small>Bozze, post e asset</small>
                        </span>
                    </button>

                    <button *ngIf="canManageClients" routerLink="/clients" routerLinkActive="active" title="Clienti">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Clienti</strong>
                            <small>Workspace e account</small>
                        </span>
                    </button>

                    <button routerLink="/crm" routerLinkActive="active" title="CRM">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>CRM</strong>
                            <small>Contatti e tag</small>
                        </span>
                    </button>

                    <button routerLink="/config" routerLinkActive="active" title="Configurazioni">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="3"></circle>
                            <path
                                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                            </path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Configurazioni</strong>
                            <small>Brand e preferenze</small>
                        </span>
                    </button>
                </div>
            </div>

            <div class="sidebar-section sidebar-section-secondary">
                <span class="sidebar-section-label">Canali e strumenti</span>
                <div class="nav-links nav-links-secondary">
                    <button *ngIf="hasWhatsappModule" routerLink="/whatsapp" routerLinkActive="active" title="WhatsApp">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
                            </path>
                        </svg>
                        <span class="nav-copy">
                            <strong>WhatsApp</strong>
                            <small>Chat e automazioni</small>
                        </span>
                    </button>

                    <button *ngIf="hasEmailModule" routerLink="/email" routerLinkActive="active"
                        title="Email Marketing">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                            </path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        <span class="nav-copy">
                            <strong>Email</strong>
                            <small>Campagne e invii</small>
                        </span>
                    </button>

                    <button *ngIf="hasCopywritingModule" routerLink="/copywriting" routerLinkActive="active"
                        title="Copywriting">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                            <path d="M6.5 17H20V4.5A2.5 2.5 0 0 0 17.5 2H7a3 3 0 0 0-3 3v14.5z"></path>
                            <path d="M9 7h8"></path>
                            <path d="M9 11h8"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Copywriting</strong>
                            <small>Testi e caption</small>
                        </span>
                    </button>

                    <button *ngIf="hasLeadGenerationModule" routerLink="/lead-generation" routerLinkActive="active"
                        title="Lead Generation">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="3"></circle>
                            <path d="M20 8v6"></path>
                            <path d="M17 11h6"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Lead Gen</strong>
                            <small>Acquisizione contatti</small>
                        </span>
                    </button>

                    <button *ngIf="hasInsightsModule" routerLink="/insights" routerLinkActive="active" title="Insights">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="20" x2="18" y2="10"></line>
                            <line x1="12" y1="20" x2="12" y2="4"></line>
                            <line x1="6" y1="20" x2="6" y2="14"></line>
                        </svg>
                        <span class="nav-copy">
                            <strong>Insights</strong>
                            <small>Performance e dati</small>
                        </span>
                    </button>

                    <button *ngIf="hasTrendsModule" routerLink="/trends" routerLinkActive="active" title="Trend">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 17l6-6 4 4 8-8"></path>
                            <path d="M14 7h7v7"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Trend</strong>
                            <small>Ispirazioni correnti</small>
                        </span>
                    </button>

                    <button routerLink="/store" routerLinkActive="active" title="Crediti">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="12" y1="1" x2="12" y2="23"></line>
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                        <span class="nav-copy">
                            <strong>Crediti</strong>
                            <small>Saldo e acquisti</small>
                        </span>
                    </button>
                </div>
            </div>

            <div class="sidebar-footer">
                <div *ngIf="currentUser?.isActingAsClient" class="workspace-hint">
                    Sei nel workspace cliente: {{ currentUser?.name || currentUser?.username }}
                </div>
                <button (click)="logout()" class="sidebar-logout-btn" title="Logout">
                    <div class="avatar-placeholder">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                    </div>
                    <span class="nav-copy">
                        <strong>Esci</strong>
                        <small>Chiudi sessione</small>
                    </span>
                </button>
            </div>
        </nav>

        <div class="content-shell" [class.editor-shell]="isEditorRoute">
            <div *ngIf="!isEditorRoute && !isSuperAdmin" class="mobile-topbar">
                <button class="hamburger-btn" (click)="toggleSidebar()" aria-label="Apri menu">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                        <line x1="3" y1="6" x2="21" y2="6"/>
                        <line x1="3" y1="12" x2="21" y2="12"/>
                        <line x1="3" y1="18" x2="21" y2="18"/>
                    </svg>
                </button>
                <div class="mobile-brand">
                    <img src="/logo_mia_sidebar.svg" alt="MIA Logo" width="22" height="22" style="object-fit:contain"/>
                    <strong>MIA Social Calendar</strong>
                </div>
            </div>
            <div *ngIf="!isEditorRoute && !isSuperAdmin && canManageClients" class="workspace-topbar">
                <div class="workspace-switcher">
                    <div class="workspace-switcher-head">
                        <label for="workspaceSelect" class="workspace-label">Workspace attivo</label>
                        <strong class="workspace-current">{{ activeWorkspaceLabel }}</strong>
                    </div>
                    <div class="workspace-switcher-main">
                        <select id="workspaceSelect" class="workspace-select" [ngModel]="selectedWorkspaceValue"
                            (ngModelChange)="onWorkspaceChange($event)">
                            <option value="self">{{ currentUser?.name || currentUser?.username }} · Azienda</option>
                            <option *ngFor="let account of managedAccounts" [value]="account.id">
                                {{ account.name || account.username }}
                            </option>
                        </select>
                        <div class="workspace-quick-list">
                            <button type="button" class="workspace-quick-btn" [class.active]="isWorkspaceActive(null)"
                                (click)="onWorkspaceChange('self')">
                                Azienda
                            </button>
                            <button type="button" class="workspace-quick-btn" *ngFor="let account of managedAccounts"
                                [class.active]="isWorkspaceActive(account.id)" (click)="onWorkspaceChange(account.id)">
                                {{ account.name || account.username }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="isAuthenticated && !isSuperAdmin && !isEditorRoute" class="credits-floating">
                <a routerLink="/store" class="credits-pill" [class.low]="isLowCredits">
                    <span class="credits-pill-icon" aria-hidden="true">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="9" fill="currentColor" fill-opacity="0.14"></circle>
                            <circle cx="12" cy="12" r="7.25" stroke="currentColor" stroke-width="1.5"></circle>
                            <path d="M12 7.2v9.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                            </path>
                            <path d="M15.4 9.2h-4.85a2.35 2.35 0 0 0 0 4.7h2.9a2.35 2.35 0 1 1 0 4.7H8.8"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            </path>
                        </svg>
                    </span>
                    <span class="credits-pill-copy">
                        <span class="credits-pill-label">Crediti residui</span>
                        <strong *ngIf="!creditsLoading">{{ formatCredits(creditBalance?.balanceCredits ?? 0) }}</strong>
                        <strong *ngIf="creditsLoading">...</strong>
                    </span>
                </a>
            </div>

            <div class="view-container" [class.editor-view]="isEditorRoute">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>